import { QuestionStatus } from '@exam-management/graphql';
import { useQuestionCreationTaskDetails } from '@exam-management/question-creation-task-details';
import { QuestionCreationWorkflowStepCodeObject } from '@exam-management/task-management';
import { Flex, SectionTitle } from '@shared/components';

import { useSingleQuestionDetails } from '../../providers';
import { DetailView } from '../detail-view';
import { DetailsFormSection } from '../details-form-section';

export default function SingleQuestionDetailsSection() {
  const { task, roles, status } = useQuestionCreationTaskDetails();
  const { singleQuestion } = useSingleQuestionDetails();

  const isInDevelopment = singleQuestion.status === QuestionStatus.InDevelopment;

  const isEditable =
    isInDevelopment &&
    roles.isAssignee &&
    status.code === QuestionCreationWorkflowStepCodeObject.QuestionCreationInProgress;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
      <SectionTitle title='Question' />
      {isEditable ? (
        <DetailsFormSection taskId={task.id} questionId={singleQuestion.id} />
      ) : (
        <DetailView />
      )}
    </Flex>
  );
}
